<template lang="pug">
.sidebar(data-color='yellow-obee')
  .logo.logo-mobile
    a(href="/")
      img(src="../../assets/Obee_Logo_140@2x.png" height="65px")
  .sidebar-wrapper
    navbar-right(v-if='open', :mobile='true')
    ul.nav(v-if="!isSideBarChild")
      li.item-arrow(v-on:click="openMenu('profile')" v-bind:class="[(isOpenMenu('profile') ? 'open-menu' : ''), (['Account', 'relation', 'Profile', 'relation-add'].includes(this.$route.name) ? 'open-menu' : '')]")
        itemArrow(:title="user ? user.fullname : 'Thông tin cá nhân'" :isActive="isOpenMenu('profile') || ['Account', 'relation', 'Profile', 'relation-add'].includes(this.$route.name)" :avatar="user && user.avatar || require('../../assets/images/faces/ic_AvatarDefault.svg')")
        ul.vs-dropdown
          item(title='Trang cá nhân' icon='person' href='/account')
          item(title="Bạn bè" href='/relation' :avatar='require("../../assets/images/menu/ic_friends_menu.png")')
      itemHeader(title="Dành cho Giáo viên" v-if="user && user.type_user !== 1")
      item(title='Tổng quan' icon='fa fa-th-large' href='/general' v-if="user && user.type_user !== 1")
      item(title='Quản lý thành viên' :avatar='require("../../assets/images/menu/ic_puzzle.png")' href='/member' v-if="user && user.type_user !== 1")
      li.item-arrow(v-on:click="openMenu('lesson')" v-bind:class="[(isOpenMenu('lesson') ? 'open-menu' : ''), (['Lesson', 'Videos', 'Category', 'lesson_add', 'lesson_edit', 'video_add', 'video_edit'].includes(this.$route.name) ? 'open-menu' : '')]" v-if="user && user.type_user !== 1")
        itemArrow(:title="'Lý thuyết môn học'" :isActive="isOpenMenu('lesson') || ['Lesson', 'Videos', 'Category', 'lesson_add'].includes(this.$route.name) " :avatar='require("../../assets/images/menu/Mask Group 48.png")')
        ul.vs-dropdown
          item(title='Danh mục bài học', :avatar='require("../../assets/images/theory/ic_danhmucbaihoc.png")', href='/category' v-if="user && user.type_user !== 1")
          item(title='Ds lý thuyết', :avatar='require("../../assets/images/menu/Mask Group 105.png")', href='/lessons' v-if="user && user.type_user !== 1" :menuChilds="['Lesson']")
          item(title='Video bài giảng', :avatar='require("../../assets/images/theory/ic_video.png")', href='/videos' v-if="user && user.type_user !== 1" :menuChilds="['Videos']")
      li.item-arrow(v-on:click="openMenu('lstExercise')" v-bind:class="[(isOpenMenu('lstExercise') ? 'open-menu' : ''), (['exercise', 'category-exercise', 'question', 'category-question', 'exercise_add', 'exercise_edit', 'question_add', 'question_edit'].includes(this.$route.name) ? 'open-menu' : '')]" v-if="user && user.type_user !== 1")
        itemArrow(:title="'Ngân hàng bài tập'" :isActive="isOpenMenu('lstExercise') || ['exercise', 'category-exercise', 'question', 'category-question'].includes(this.$route.name) " :avatar='require("../../assets/images/menu/Mask Group 127.png")')
        ul.vs-dropdown
          item(title='Danh sách bài tập', :avatar='require("../../assets/images/menu/ic_dsbaitap.png")', href='/exercise' v-if="user && user.type_user !== 1" :menuChilds="['exercise']")
          item(title='Danh mục bài tập', :avatar='require("../../assets/images/menu/ic_danhmucbaitap.png")', href='/category-exercise' v-if="user && user.type_user !== 1")
          item(title='Danh sách câu hỏi', :avatar='require("../../assets/images/menu/ic_dscauhoi.png")', href='/question' v-if="user && user.type_user !== 1" :menuChilds="['question']")
          item(title='Danh mục câu hỏi', :avatar='require("../../assets/images/menu/ic_danhmuccauhoi.png")', href='/category-question' v-if="user && user.type_user !== 1")
      item(title='Quản lý giáo án' :avatar='require("../../assets/images/menu/Mask Group 106.png")' href='/lesson-planning' v-if="user && user.type_user !== 1")
      item(title='Bài tập của tôi' :avatar='require("../../assets/images/menu/ic_baitapcuatoi.png")' href='/result' v-if="user && user.type_user === 1")
      item(title='Lớp học của tôi' :avatar='require("../../assets/images/menu/Mask Group 155.png")' href='/classes-to-me' v-if="user && user.type_user === 1")
      //- li.item-arrow(v-on:click="openMenu('quickanswer')" v-bind:class="[(isOpenMenu('quickanswer') ? 'open-menu' : '')]")
      //-   itemArrow(:title="'Hỏi đáp nhanh'" :isActive="isOpenMenu('quickanswer')" icon="fa fa-puzzle-piece")
      //-   ul.vs-dropdown
      //-     item(title='Ds lý thuyết', icon='all_inclusive', href='lessons' v-if="user && user.type_user !== 1")
      //-     item(title='Video bài giảng', icon='all_inclusive', href='videos' v-if="user && user.type_user !== 1")
    ul.nav(v-else) 
      itemLevel(title='Lớp học của tôi', href='/classes-to-me' v-if="user && user.type_user === 1")
  .sidebar-background
</template>
<script>
import item from './item'
import itemHeader from './itemHeader'
import itemArrow from './itemArrow'
import itemLevel from '../ClassesMe/itemSideBarLevel'
import NavbarSearch from '@/components/Navigation/navbar-search'
import NavbarRight from '@/components/Navigation/navbar-right'
import store from '../../store'
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import mdLogout from '../Account/Logout'

export default {
  props: {
    open: Boolean
  },
  components: {
    item,
    itemHeader,
    itemArrow,
    itemLevel,
    NavbarSearch,
    NavbarRight
  },
  data() {
    return {
      user: null,
      activeItem: this.$route.name,
      isOpen: (this.$route.name !== undefined && this.$route.name !== null),
      isSideBarChild: false,
      lstRouteLevelSideBar: ['classes_to_me']
    }
  },
  methods: {
    openMenu(menuItem) {
      if (this.activeItem !== '') {
        if (this.activeItem !== menuItem) {
          this.activeItem = menuItem
          this.isOpen = true
        } else {
          this.activeItem = ''
          this.isOpen = false
        }
      } else {
        this.activeItem = menuItem
        this.isOpen = true
      }
    },
    isOpenMenu: function(menuItem) {
      return this.isOpen && this.isActive(menuItem)
    },
    isActive: function (menuItem) {
      return this.activeItem === menuItem
    },
    submitLogout() {
      this.$modal.show(mdLogout, {}, {
        clickToClose: false,
        height: 'auto',
        adaptive: true,
        classes: ['col-md-6'],
        reset: true
      })
    },
    asyncSideBar($route) {
      // console.log('route', this.$route)
      this.isSideBarChild = false
      if ($route.meta.parentName !== undefined && $route.meta.parentName !== null && $route.meta.parentName !== '' && this.lstRouteLevelSideBar.includes($route.meta.parentName)) {
        this.isSideBarChild = true
      }
    }
  },
  async created() {
    const res = await this.$apollo.query({
      query: gql(graphql.GET_FULLNAME),
      variables: {
        uid: store.getters.user
      }
    })
    // console.log(res)
    if (res) {
      this.user = res.data.v_user_public[0]
      store.commit('setFullname', res.data.v_user_public[0])
    }
    this.asyncSideBar(this.$route)
  },
  watch: {
    '$route' (to, from) {
      this.asyncSideBar(this.$route)
    }
  },
  apollo: {
  }
}
</script>

<style lang="scss">
.close-layer{right: 0; width: calc(100% - 260px);}
.wrapper{
  &.nav-open{
    .sidebar{display: none;transition: all 0.5s ease 0s;-webkit-transition: all 0.5s ease 0s;}
    .main-panel{width: 100%; transition: all 0.5s ease 0s;-webkit-transition: all 0.5s ease 0s;}
  }
  .sidebar{background: #FAFAFA 0% 0% no-repeat padding-box;display: block;box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
    .logo{padding: 10px 15px;background: #FAFAFA;
      &:after{background: transparent;}
    }
    .sidebar-wrapper{background: #FAFAFA 0% 0% no-repeat padding-box;
      ul.nav{ margin-top: 0;
        li{
          a{margin: 0; padding: 10px; display: flex; width: 100%;
            .icon-header{width: 24px; height: 24px;margin-right: 10px; position: relative;top:0px; text-align: center;border-radius: 50%;
              &.remove-img{width: 0; margin: 0;}
              .avt-sidebar{
                width: 24px; height: 24px; border-radius: 50%; overflow: hidden;
                img{max-width: 100%; height: auto;}
              }
              .fontawesome{margin: 0; position: relative; top:-3px;
                i{font-size: 16px;}
              }
              .material-icons{font-size: 20px;margin-left: 5px;}
            }
            .text-header{width: calc(100% - 35px);
              &.full-text{width: 100%;}
              span.header{text-align: left; font-weight: bold; font-size: 15px; font-family: Helvetica;letter-spacing: 0px;color: #343A40;text-transform: uppercase; }
            }
          }
          &.item-arrow{
            .icon-header{top:0;}
            .text-header{position: relative;top: 3px;}
            .vs-arrow{position: relative; top: 5px;}
          }
          &.item-link{
            .parent{
              &.active{background: #FFD311 0% 0% no-repeat padding-box;
                .text-header{font-weight: bold;color: #343A40;}
              }
            }
          }
          ul{list-style: none;background: #FAFAFA 0% 0% no-repeat padding-box;padding: 0; display: none;
              li{
                a{
                  .icon{color: #343A40;}
                }
                a.active, a:hover{color: #343A40; font-weight: bold;
                  .icon{color: #343A40;}
                }
              }
            }
            &.open-menu{background: #FFD311 0% 0% no-repeat padding-box;
              &.active-menu{
                .vs-dropdown{display: block;background: #FBF4D2 0% 0% no-repeat padding-box;}
              }
              .parent{
                .text-header{font-weight: bold;color: #343A40;}
              }
              .vs-dropdown{display: block;background: #FBF4D2 0% 0% no-repeat padding-box;
                li{
                  a{background: transparent !important;
                    &.active, &:focus, &:hover{
                      .text-header{ font-weight: bold;}
                    }
                    .text-header{font-weight: normal;}
                  }
                }
              }
            }
        }
      }
    }
  }
  .main-panel{transition: all 0.5s ease 0s;-webkit-transition: all 0.5s ease 0s;}
}
@media (max-width: 991px){
  .wrapper{
    .sidebar .nav-mobile-menu{display: none;}
    .sidebar, .off-canvas-sidebar{right: auto; left: 0;transform: translate3d(-260px, 0, 0);transition: all 0.5s ease 0s;-webkit-transition: all 0.5s ease 0s;}
    &.nav-open{
      .sidebar, .off-canvas-sidebar{display: block;transform: translate3d(0, 0, 0);}
      .main-panel{transform: translate3d(0, 0,0);}
    }
  }
}
@media (max-width: 767px){
  .wrapper{
    .sidebar .nav-mobile-menu{display: none;}
    .sidebar, .off-canvas-sidebar{right: auto; left: 0;transform: translate3d(-260px, 0, 0);transition: all 0.5s ease 0s;-webkit-transition: all 0.5s ease 0s;}
    &.nav-open{
      .sidebar, .off-canvas-sidebar{display: block;transform: translate3d(0, 0, 0);}
      .main-panel{transform: translate3d(0, 0, 0);}
    }
  }
}
</style>




// WEBPACK FOOTER //
// index.vue?09e067bc